<!--
  @component Navbar.Brand

  A component for displaying the brand logo or text in the navbar.

  @prop href - The URL the brand link points to (default: "/")
  @prop css - Custom CSS styles to apply to the brand element


  Example:
  <Navbar.Brand href="/">
    <img src={Logo} alt="Company Logo" />
  </Navbar.Brand>
-->

<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { navbarStyles } from '../navbar.styles';
  import type { NavbarBrandProps } from '../navbar.types';

  /**
   * Props for the Navbar.Brand component.
   * @type {NavbarBrandProps}
   */
  const { children, css: cssProp = {}, href = "/" }: NavbarBrandProps = $props();

  /**
   * Classes for the brand element, derived from navbar styles.
   * @type {Record<string, string>}
   */
  const classes = navbarStyles.raw();
</script>

<a
  href={href}
  class={css(classes.brand, cssProp)}
>
  {#if children}
    {@render children()}
  {/if}
</a>